<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="小店/关联账号" name="name"></c-form-item>
                    <c-form-item type="checkbox" label="状态" name="states" :options="stateOption"></c-form-item>
                </c-form>
            </m-search>
            <m-operate>
                <c-button power="b_live_shop_sync" color="black" hollow @click="syncHandle('shop')">同步小店账号（每1小时自动）</c-button>
				<c-button power="b_live_talent_sync" color="black" hollow @click="syncHandle('talent')">同步达人账号（每1小时自动）</c-button>
                <c-button power="b_live_shop_live_sync" color="sys" @click="syncHandle('shop_live')">同步小店直播（每5分钟自动）</c-button>
                <c-button power="b_live_talent_live_sync" color="sys" @click="syncHandle('talent_live')">同步达人直播（每5分钟自动）</c-button>
            </m-operate>
            <c-table ref="table">

                <c-table-column
                    label="小店/达人名称"
                    name="nickname"
                    width="150"
                >
                </c-table-column>
				
				<c-table-column
				    label="小店/达人Appid"
				    name="appid"
				    width="150"
				>
				</c-table-column>

               <!-- <c-table-column
                        label="小店头像"
                        name="avatar_image_url"
                        width="80"
                >
                    <template v-slot="{data}">
                        <c-image v-if="data.headimg_url" type="image" :src="data.headimg_url" preview size="30" style="margin-right: 10px;"> </c-image>
                        <span v-else>-</span>
                    </template>
                </c-table-column> -->

				<c-table-column
                    label="类型"
                    name="bind_type"
                    width="60"
                >
                    <template v-slot="{data}">
                        <span v-if="data.bind_type==1" style="color: blue">小店</span>
                        <span v-if="data.bind_type==2" style="color: green">达人</span>
                    </template>
                </c-table-column>

               <c-table-column
                    label="账号类型"
                    name="promoter_type"
                    width="70"
                >
                    <template v-slot="{data}">
                        <span v-if="data.promoter_type==1" style="color: blue">视频号</span>
                        <span v-if="data.promoter_type==2" style="color: green">公众号</span>
                        <span v-if="data.promoter_type==3" style="color: brown">服务号</span>
                    </template>
                </c-table-column>

                <!-- <c-table-column
                    label="关联账号头像"
                    name="avatar_image_url"
                    width="110"
                >
                    <template v-slot="{data}">
                        <c-image v-if="data.avatar_image_url" :src="data.avatar_image_url" preview size="30" style="margin-right: 10px;"> </c-image>
                        <span v-else>-</span>
                    </template>
                </c-table-column> -->

                <c-table-column
                    label="小店关联账号名称"
                    name="promoter_name"
                    width="130"
                >
					<template v-slot="{data}">
					    <span v-if="data.promoter_name">{{data.promoter_name}}</span>
					    <span v-else style="color: darkgray">-</span>
					</template>
                </c-table-column>

                <c-table-column
                        label="推广用户数"
                        name="share_count"
                        width="90"
                >
                    <template v-slot="{data}">
                        <span v-if="data.share_count && data.share_count > 0" style="color:blue">{{data.share_count}}</span>
                        <span v-else style="color: darkgray">0</span>
                    </template>
                </c-table-column>

                <c-table-column
                    label="正在直播数"
                    name="live_count"
                    width="90"
                >
                    <template v-slot="{data}">
                        <span v-if="data.live_count && data.live_count > 0" style="color:blue;">{{data.live_count}}</span>
                        <span v-else style="color: darkgray">0</span>
                    </template>
                </c-table-column>

                <c-table-column
                    label="预约直播数"
                    name="yy_count"
                    width="90"
                >
                    <template v-slot="{data}">
                        <span v-if="data.yy_count && data.yy_count > 0" style="color:blue">{{data.yy_count}}</span>
                        <span v-else style="color: darkgray">0</span>
                    </template>
                </c-table-column>

                <c-table-column
                    label="创建时间"
                    name="create_date"
                    width="150"
                >
                </c-table-column>

                <c-table-column
                    label="状态"
                    name="state"
                    width="60"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state==1" style="color: green">启用</span>
                        <span v-if="data.state==2" style="color: red">禁用</span>
                    </template>
                </c-table-column>

                <c-table-column
                    label="直播间福利"
                    name="zbjfl_remak"
                    width="350"
                >
                    <template v-slot="{data}">
                        <span v-if="data.zbjfl_remak">{{data.zbjfl_remak}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                    label="最高返利比例"
                    name="max_back_ratio"
                    width="110"
                >
                    <template v-slot="{data}">
                        {{data.max_back_ratio}}%
                    </template>
                </c-table-column>

                <c-table-column
                    type="button"
                    fixed="right"
                    label="操作"
                    width="130"
                >
                    <template v-slot="row">
                        <c-table-button power="b_live_shop_promoter_edit" @click="edit(row.data)">编辑直播信息</c-table-button>
                        <c-table-button power="b_live_shop_appsecret_edit" @click="editAppsecret(row.data)">AppSecret</c-table-button>
                        <c-table-button power="b_live_shop_promoter_edit" v-if="row.data.state == 2" @click="startHandle('1', row.data)">启用</c-table-button>
                        <c-table-button power="b_live_shop_promoter_edit" v-if="row.data.state == 1" @click="startHandle('2', row.data)">禁用</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
			
            <c-dialog ref="editDialog" title="编辑直播信息" width="750" @resolve="submitEdit">
                <c-form ref="editForm">
                    <c-form-item type="hidden" name="id"></c-form-item>
                    <c-form-item type="number" decimal="0" label="最高返利比例" :limit="[1,70]" name="max_back_ratio" required input-unit="%"></c-form-item>
                    <c-form-item type="textarea" label="直播间福利" name="zbjfl_remak" maxlength="200" required></c-form-item>
                </c-form>
            </c-dialog>
			
			<c-dialog ref="editAppsecretDialog" title="编辑AppSecret" width="600" @resolve="submitAppsecretEdit">
			    <c-form ref="editAppsecretForm">
			        <c-form-item type="hidden" name="mcn_shop_id"></c-form-item>
			        <c-form-item label="AppSecret" type="input" name="appsecret" required></c-form-item>
			    </c-form>
			</c-dialog>
        </module>
    </page>
</template>

<script>
    export default {
        name: 'm_live_shop_promoter',

        data() {
            return {
                promoterTypeOption:[
                    {name:'视频号', value:1},
                    {name:'公众号', value:4},
                    {name:'服务号', value:5}
                ],
                stateOption:[
                    {name:'启用', value:1},
                    {name:'禁用', value:2}
                ]
            }
        },

        mounted() {
            this.$refs.search.search();
            this.$bus.$on('liveUserList.update', () => {
                this.$refs.search.search();
            });
        },

        methods: {

            searchHandle(data) {
                this.$refs.table.load({
                    url: '/mcn/shop/promoter/list',
                    data
                });
            },
			
            /**打开 新增/编辑 弹窗**/
            edit(data){
                //清空表单数据
                this.$refs.editForm.clear();
                this.$refs.editDialog.open();
                this.$refs.editForm.set(data);
            },
            /**提交修改**/
            submitEdit(stop){
                stop();
                this.$refs.editForm.submit({
                    url: '/mcn/shop/promoter/edit',
                    rule: {
                        max_back_ratio: '请输入最高返利比例',
                        zbjfl_remak: '请输入直播间福利'
                    },
                    dataFormatter: data => {
                        return data;
                    },
                    success: (data, res) => {
                        //关闭弹窗
                        this.$refs.editDialog.close();
                        this.$message({
                            text:'编辑成功！'
                        });
                        // 清空表单数据
                        this.$refs.editForm.clear();
                        this.$refs.search.search();
                    }
                });
            },
			
			/**打开 新增/编辑 弹窗**/
			editAppsecret(data){
			    //清空表单数据
			    this.$refs.editAppsecretForm.clear();
			    this.$refs.editAppsecretDialog.open();
			    this.$refs.editAppsecretForm.set(data);
			},
			/**提交修改**/
			submitAppsecretEdit(stop){
			    stop();
			    this.$refs.editAppsecretForm.submit({
			        url: '/mcn/shop/editupdateShopAppsecret',
			        rule: {
			            appsecret: '请输入小店AppSecret',
			        },
			        dataFormatter: data => {
			            return data;
			        },
			        success: (data, res) => {
						this.$refs.table.update();
			            //关闭弹窗
			            this.$refs.editAppsecretDialog.close();
			            this.$message({
			                text:'编辑小店AppSecret成功！'
			            });
			            // 清空表单数据
			            this.$refs.editAppsecretForm.clear();
			        }
			    });
			},
			
            //启用、禁用
            startHandle(type, data) {
                this.$confirm({
                    text: `确定要${type == '1' ? '停用' : '启用'}该直播用户吗？`,
                    resolve: () => {
                        this.request({
                            url: '/mcn/shop/promoter/updateState',
                            data: {
                                id: data.id,
                                state: type
                            },
                            loading: true,
                            success: () => {
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },
            //同步数据
            syncHandle(type, item) {
                /*var list = item ? [{
                    data: item
                }] : this.$refs.table.getRow('selected');
                if (!list.length) {
                    this.$message({
                        text: '请选择需要操作的小店记录'
                    });
                    return;
                }*/
                if (type == 'shop'){
				//同步小店
					this.request({
						url: '/mcn/shop/sync',
						data: {},
						loading: true,
						success: () => {
							this.$message({
								text:'小店及关联账号同步成功！'
							});
							this.$refs.table.update();
						}
					});
				}else if (type == 'talent'){
				//同步达人
					this.request({
						url: '/mcn/talent/sync',
						data: {},
						loading: true,
						success: () => {
							this.$message({
								text:'达人信息同步成功！'
							});
							this.$refs.table.update();
						}
					});
                }else if (type == 'shop_live'){
				//同步小店直播
                    this.request({
                        url: '/mcn/shop/live/sync',
                        data: {},
                        loading: true,
                        success: () => {
                            this.$message({
                                text:'小店直播及直播预告同步成功！'
                            });
                            this.$refs.table.update();
                        }
                    });
                }else if (type == 'talent_live'){
                //同步达人直播
                    this.request({
                        url: '/mcn/talent/live/sync',
                        data: {},
                        loading: true,
                        success: () => {
                            this.$message({
                                text:'达人直播及直播预告同步成功！'
                            });
                            this.$refs.table.update();
                        }
                    });
                }
            },
        }
    }
</script>